import {Tabs} from "antd";
import {useState, useEffect} from "react";
import {Fade} from "react-awesome-reveal";
import service from "../service";
import TimelineNew from "./TimelineNew";
import GeneralBudget2 from "./GeneralBudget2";
import NewHome from "../newHome/NewHome";
import MinistryPicker from "../MinistryPicker";
const {TabPane} = Tabs;

function Budget() {
  const [timeLine, SetTimeLine] = useState([]);
  useEffect(() => {
    service
      .getTimeLine()
      .then((res) => {
        if (res.success) {
          SetTimeLine(res.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }, []);
  return (
    <div className="budget-containerr" style={{paddingTop: "61.2px"}}>
      <MinistryPicker />
      <Fade delay={400}>
        <Tabs
          className="budget-tabs"
          defaultActiveKey="1"
          type="card"
          size="middle"
          style={{marginTop: "1.5rem"}}
        >
          <TabPane
            className="budget-tab"
            tab={<span className="tab-span">Нэгдсэн төсөв</span>}
            key="1"
          >
            <GeneralBudget2 />
          </TabPane>
          <TabPane
            className="budget-tab"
            style={{borderRadius: "1rem"}}
            tab={<span className="tab-span">Төсвийн цаглабар</span>}
            key="2"
          >
            <TimelineNew timeline={timeLine} />
          </TabPane>
          <TabPane
            className="budget-tab"
            tab={<span className="tab-span">Хөрөнгө оруулалт</span>}
            key="3"
          >
            {/* <Investment2 /> */}
            <NewHome />
          </TabPane>
        </Tabs>
      </Fade>
    </div>
  );
}

export default Budget;
